export const faqs = [
  {
    q: "How will I receive Facelift Blueprint™?",
    a: ["After your purchase, you'll receive instructions for accessing and downloading the digital materials included in the product."],
  },
  {
    q: "Who is Facelift Blueprint™ for?",
    a: ["It's designed for plastic surgeons and appropriately qualified physicians who want a more structured way to organize their educational review of facelift cases."],
  },
  {
    q: "Is this a surgical technique course?",
    a: [
      "No. Facelift Blueprint™ is a structured educational review system. It includes learning frameworks, worksheets, educational case exercises, and review tools.",
      "It is not a substitute for formal surgical training, supervised practice, or specialist mentorship.",
    ],
  },
  {
    q: "Does the Blueprint provide a universal step-by-step surgical protocol?",
    a: [
      "No. Facelift procedures vary according to patient characteristics, clinical context, professional training, and the techniques being studied.",
      "The Blueprint helps organize educational review. It does not establish a universal operative sequence or provide patient-specific surgical instructions.",
    ],
  },
  {
    q: "How long does each case review take?",
    a: [
      "The system includes a framework designed for an approximately 15-minute educational review, along with a condensed 10-minute worksheet.",
      "Actual review time depends on the complexity of the educational material and how much additional reading is required.",
    ],
  },
  {
    q: "Can I print the materials?",
    a: ["Yes. The worksheets and printable resources are designed for digital use and printing."],
  },
  {
    q: "Is this a one-time payment?",
    a: ["Yes. The advertised price is a one-time payment of $27 USD, with no recurring subscription fees. Currency conversion is automatic at checkout."],
  },
  {
    q: "How long will I have access?",
    a: ["The offer includes lifetime access to the purchased digital materials, subject to the applicable purchase terms."],
  },
  {
    q: "What if I don't like the product?",
    a: ["The offer includes a seven-day money-back guarantee. Contact us within the guarantee period according to the purchase terms to request a refund."],
  },
  {
    q: "Does the Blueprint guarantee better surgical outcomes?",
    a: ["No. The product is intended for professional education and structured learning. It does not guarantee clinical outcomes or replace current evidence, supervised training, institutional protocols, or individualized clinical judgment."],
  },
];
